<template>
  <div
    v-if="showNotification"
    class="version-notifier"
    data-testid="version-notifier"
  >
    <div class="version-notifier-header">
      <p class="version-notifier-title" data-testid="version-notifier-title">
        {{ t("common.system.version") }}

        {{ version }}
      </p>
    </div>
    <p class="version-notifier-message" data-testid="version-notifier-message">
      {{ t("common.system.updateMessage") }}
    </p>
    <DsButton
      :loading-label="$t('common.button.loading')"
      data-testid="update-button"
      class="version-notifier-button"
      @click="onClickUpdate"
    >
      {{ t("common.button.update") }}
    </DsButton>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

import { storeToRefs } from "pinia";
import { useVersionNotifierStore } from "@/store/VersionNotifierStore";

import { DsButton } from "@devsalsa/vue-core";

import { useI18n } from "vue-i18n";

const { t } = useI18n();
const versionNotifierStore = useVersionNotifierStore();
const { version } = storeToRefs(versionNotifierStore);

const showNotification = ref<boolean>(false);

watch(
  () => version.value,
  (oldVersion, newVersion) => {
    if (oldVersion !== "" && newVersion && oldVersion !== newVersion) {
      showNotification.value = true;
    }
  }
);

const onClickUpdate = () => {
  showNotification.value = false;
  location.reload();
};
</script>

<style lang="scss" scoped>
.version-notifier {
  @apply fixed bg-white p-4 left-6 bottom-6 w-80 h-auto rounded-r-md border-l-4 border-blue-600 shadow drop-shadow shadow-gray-200 z-50;

  &-header {
    @apply flex flex-row items-center justify-between text-gray-500;

    &-title {
      @apply text-sm font-medium text-gray-900;
    }
  }

  &-message {
    @apply text-sm font-normal text-gray-500 mt-1 w-[200px];
  }

  &-button {
    @apply mt-4;
  }
}
</style>
